module.exports = __webpack_public_path__ + "img/p_sz_12.d284fbfe.png";